import { AGENT_GLOBAL_BUILTIN_NAMES, isLifecycleDbTool } from 'constants/agenticToolTriggers';

/**
 * Rows for agent-level attachedTools (lifecycle / global tools).
 */
export function agentGlobalToolRows(agent, allTools = []) {
  const attachments = agent?.attachedTools || [];
  const toolById = new Map((allTools || []).map(t => [String(t._id), t]));

  return attachments
    .map(att => {
      if (att?.builtin) {
        if (!AGENT_GLOBAL_BUILTIN_NAMES.includes(att.builtin)) return null;
        return {
          _id: `builtin:${att.builtin}`,
          name: att.builtin,
          description: att.usage || '',
          kind: 'builtin',
          builtin: true,
          trigger: 'onStart',
          usage: att.usage || '',
          attachment: att,
        };
      }
      if (att?.tool) {
        const doc = toolById.get(String(att.tool));
        if (!doc) return null;
        return {
          ...doc,
          _id: String(doc._id),
          description: doc.description,
          usage: att.usage || '',
          attachment: att,
        };
      }
      return null;
    })
    .filter(Boolean);
}

export function lifecycleCatalogTools(allTools = []) {
  return (allTools || []).filter(isLifecycleDbTool);
}
